<div class="recorte-foto">
  <div class="recorte-foto-topo">
    <span class="recorte-foto-titulo">Recortar foto</span>
    @if (dados.total > 1) {
      <span class="recorte-foto-contador">Foto {{ dados.posicao }} de {{ dados.total }}</span>
    }
  </div>

  <image-cropper class="recorte-foto-area" [imageFile]="dados.arquivo" [aspectRatio]="1"
    [maintainAspectRatio]="true" [autoCrop]="false" [(cropper)]="posicaoRecorte"
    (imageLoaded)="onImagemCarregada($event)" (cropperReady)="pronto = true" (loadImageFailed)="onFalhaAoCarregar()">
  </image-cropper>

  <div class="recorte-foto-botoes">
    <button mat-button type="button" class="btn-cancelar-recorte" (click)="cancelar()">Cancelar</button>
    <button mat-flat-button type="button" class="white-text-button btn-confirmar-recorte" [disabled]="!pronto"
      (click)="confirmar()">
      Confirmar
    </button>
  </div>
</div>
